import axios from "axios";
import { ENV } from "../config/clientConfig";

const { api } = ENV;

export const searchData = (value, setState) => {
  return axios
    .post(
      `${api}/api/user/search`,
      {
        value: value,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
      setState((prev) => ({ ...prev, valueData: res.data.results }));
    })
    .catch((error) => {
      console.error(error);
      setState((prev) => ({ ...prev, error: "Search must have a value." }));
    });
};

export const expandSearchedValue = (id, valueData) => {
  return axios
    .get(`${api}/api/user/${id}`)
    .then((res) => {
      valueData[
        Array.prototype.findIndex.call(
          valueData,
          (user) => user.id === res.data.id
        )
      ].station = res.data.station;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const checkPhone = (id, valueData) => {
  return axios
    .get(`${api}/api/telephony/${id}`)
    .then((res) => {
      const phoneData = res.data[0];
      if (phoneData) {
        const userIndex = valueData.findIndex((user) => {
          const { station } = user;
          const lineId = phoneData.lines[0].id;
          return (
            station?.associatedStation?.id === lineId ||
            station?.effectiveStation?.id === lineId ||
            station?.defaultStation?.id === lineId ||
            id === user.id
          );
        });

        if (userIndex !== -1) {
          valueData[userIndex].webRtcPhone = phoneData;
        }
      }
    })
    .catch((error) => {
      console.error(id);
      console.error(error);
    });
};

export const handlePhoneAction = (
  id,
  action,
  setState,
  expandSearchedValue,
  checkPhone
) => {
  const loadingKey =
    action === "reassociateStation"
      ? "loadingReassociateUserId"
      : "loadingRebootUserId";
  const userIdKey =
    action === "reassociateStation" ? "reassociateUserId" : "rebootUserId";
  setState((prev) => ({ ...prev, [loadingKey]: id }));
  return axios
    .get(`${api}/api/telephony/${action}/${id}`)
    .then((res) => {
      console.log(res);
      setTimeout(
        () =>
          setState((prev) => ({
            ...prev,
            [loadingKey]: null,
            [userIdKey]: id,
          })),
        500
      );
      setTimeout(
        () => setState((prev) => ({ ...prev, [userIdKey]: null })),
        2000
      );
      expandSearchedValue(id);
      checkPhone(id);
    })
    .catch((error) => {
      console.error(error);
    });
};


export const handleCreatePhone = async (id, name, org, setState) => {
  try {
    setState((prev) => ({ ...prev, loading: true }));
    const response = await axios.post(`${api}/api/telephony/createPhone`, {
      id,
      name,
      org,
    });

    if (response.status === 200) {
      const newPhone = response.data; // Assume the API returns the created phone details
      setState((prev) => ({
        ...prev,
        valueData: prev.valueData.map((user) =>
          user.id === id ? { ...user, webRtcPhone: newPhone } : user
        ),
        loading: false,
      }));
    }
  } catch (error) {
    console.error("Error creating phone:", error);
    setState((prev) => ({ ...prev, loading: false, error: "Failed to create phone." }));
  }
};